import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  WorkOrderTag,
  WorkOrderTagsCreateRequest,
  WorkOrderTagsQueryFilter,
  WorkOrderTagsUpdateRequest,
} from './WorkOrdersTags.types';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/tags`;

export async function listWorkOrdersTags(params?: WorkOrderTagsQueryFilter) {
  const result = (await api.get(`${CONTROLLER_URL}`, {
    ...params,
  })) as unknown;

  return result as PageResult<WorkOrderTag>;
}

export async function createWorkOrderTag(obj: WorkOrderTagsCreateRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function updateWorkOrderTag(obj: WorkOrderTagsUpdateRequest) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function deleteWorkOrderTag(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
